angular.module('impactx.themeworld').controller('ThemeWorldListCtrl', [
    'ConfirmationService',
    'ToastService',
    'TranslationService',
    'dataGen',
    '$redirect',
    'selectedListItems',
    ThemeWorldListCtrl
]);

function ThemeWorldListCtrl(ConfirmationService, ToastService, TranslationService, dataGen, $redirect, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewThemeWorld'
        },
        {
            label: "delete",
            action: deleteThemeWorlds,
            condition: selectedListItems.isMultiSelection,
            process: 'EditThemeWorld'
        },
        {
            label: "indexing",
            action: indexingThemeWorlds,
            process: 'EditThemeWorld',
            condition: selectedListItems.isSingleSelection
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/themeworld/templates/themeworldlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/themeworld/list',
        id: "themeworldlist",
        mainAction: {id: "new", link: "#/themeworld/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function deleteThemeWorlds() {
        var themeWorldIds = selectedListItems.getSelectedIds('id');
        ConfirmationService.showConfirmationDialog(function () {
            // list framework provides ids as strings, provides an error while parsing on backend
            var idsAsIntegers = [];
            for (var i = 0; i < themeWorldIds.length; i++) {
                var id = parseInt(themeWorldIds[i]);
                if (id && !isNaN(id)) {
                    idsAsIntegers.push(id);
                }
            }
            dataGen.postAsForm({}, {ids: idsAsIntegers}, "/themeworld/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.reload();
            });
        }, undefined, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }
    function indexingThemeWorlds() {
        dataGen.postAsForm({}, {vcatId: selectedListItems.getFirstSelectedId()}, "/themeworld/ThemeworldAddToQueue").then(function (data) {
            ToastService.openStandardToast(impactX.isDefined(data, "trns.successMessage"));
        })
    };

    function getDetailLink() {
        return "themeworld/" + selectedListItems.getFirstSelectedId() + "/1";
    }
}